import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { FRAGMENT_BRAND_TERM } from './schema';

const MUTATION = gql`
  mutation CreateBrandTerm(
    $brandVoiceId: ID!
    $term: String!
    $approvalType: BrandTermApprovalTypeEnum!
    $description: String
    $approvedUseExamples: [String!]
    $replaceWith: String
    $tags: [String!]
    $enabled: Boolean
  ) {
    createBrandTerm(
      brandVoiceId: $brandVoiceId
      term: $term
      approvalType: $approvalType
      description: $description
      approvedUseExamples: $approvedUseExamples
      replaceWith: $replaceWith
      tags: $tags
      enabled: $enabled
    ) {
      ...BrandTerm
    }
  }
  ${FRAGMENT_BRAND_TERM}
`;

export const createBrandTerm = ({
  brandVoiceId,
  term,
  approvalType,
  description,
  approvedUseExamples,
  replaceWith,
  tags,
  enabled,
}) => {
  const variables = {
    brandVoiceId,
    term,
    approvalType,
    description,
    approvedUseExamples,
    replaceWith,
    tags,
    enabled,
  };

  return apolloClient
    .mutate({
      mutation: MUTATION,
      variables,
    })
    .then(({ data }) => getSingleProp(data));
};
